// Badge/Achievement definitions
// Computed from history + streak data (no DB table needed)

export const ACHIEVEMENT_GROUPS = [
  {
    id: "streak",
    label: "🔥 Streak",
    color: "#F59E0B",
    items: [
      { id: "streak_3", emoji: "🔥", title: "Khởi Động", desc: "Streak 3 ngày", check: (s) => s.longest_streak >= 3 },
      { id: "streak_7", emoji: "💪", title: "Tuần Lễ Vàng", desc: "Streak 7 ngày", check: (s) => s.longest_streak >= 7 },
      { id: "streak_14", emoji: "⚡", title: "2 Tuần Kiên Trì", desc: "Streak 14 ngày", check: (s) => s.longest_streak >= 14 },
      { id: "streak_30", emoji: "🏅", title: "Tháng Thép", desc: "Streak 30 ngày", check: (s) => s.longest_streak >= 30 },
      { id: "streak_60", emoji: "💎", title: "Kim Cương", desc: "Streak 60 ngày", check: (s) => s.longest_streak >= 60 },
      { id: "streak_100", emoji: "👑", title: "Bậc Thầy", desc: "Streak 100 ngày", check: (s) => s.longest_streak >= 100 },
      { id: "streak_365", emoji: "🌟", title: "Huyền Thoại", desc: "Streak 365 ngày", check: (s) => s.longest_streak >= 365 },
    ],
  },
  {
    id: "completion",
    label: "✅ Hoàn Thành",
    color: "#10B981",
    items: [
      { id: "done_1", emoji: "🌱", title: "Bước Đầu Tiên", desc: "Hoàn thành 1 thử thách", check: (_, h) => h.filter(x => x.completed).length >= 1 },
      { id: "done_10", emoji: "🌿", title: "Đang Lớn", desc: "Hoàn thành 10 thử thách", check: (_, h) => h.filter(x => x.completed).length >= 10 },
      { id: "done_25", emoji: "🌳", title: "Vững Vàng", desc: "Hoàn thành 25 thử thách", check: (_, h) => h.filter(x => x.completed).length >= 25 },
      { id: "done_50", emoji: "🎯", title: "Nửa Trăm", desc: "Hoàn thành 50 thử thách", check: (_, h) => h.filter(x => x.completed).length >= 50 },
      { id: "done_100", emoji: "💯", title: "Bách Chiến", desc: "Hoàn thành 100 thử thách", check: (_, h) => h.filter(x => x.completed).length >= 100 },
      { id: "done_365", emoji: "🏆", title: "Cả Năm Không Nghỉ", desc: "Hoàn thành 365 thử thách", check: (_, h) => h.filter(x => x.completed).length >= 365 },
    ],
  },
  {
    id: "explore",
    label: "🎨 Khám Phá",
    color: "#8B5CF6",
    items: [
      { id: "cat_3", emoji: "🎨", title: "Đa Năng", desc: "Thử 3 lĩnh vực khác nhau", check: (_, h) => new Set(h.filter(x => x.completed).map(x => x.category_id)).size >= 3 },
      { id: "cat_6", emoji: "🦋", title: "Toàn Diện", desc: "Thử cả 6 lĩnh vực", check: (_, h) => new Set(h.filter(x => x.completed).map(x => x.category_id)).size >= 6 },
    ],
  },
  {
    id: "reflect",
    label: "📝 Suy Tư",
    color: "#3B82F6",
    items: [
      { id: "reflect_5", emoji: "📝", title: "Người Suy Tư", desc: "Viết 5 cảm nhận", check: (_, h) => h.filter(x => x.reflection).length >= 5 },
      { id: "reflect_20", emoji: "🧘", title: "Triết Gia", desc: "Viết 20 cảm nhận", check: (_, h) => h.filter(x => x.reflection).length >= 20 },
    ],
  },
];

// Flat list for backward compat
export const ACHIEVEMENTS = ACHIEVEMENT_GROUPS.flatMap(g => g.items);

export function computeAchievements(streak, history) {
  const unlocked = [];
  const locked = [];
  for (const ach of ACHIEVEMENTS) {
    if (ach.check(streak, history)) {
      unlocked.push(ach);
    } else {
      locked.push(ach);
    }
  }
  return { unlocked, locked };
}
